// eslint-disable-next-line import/no-cycle
import { checkAndUpdateCurrentDataset } from "../datasets/dataset.service";

// eslint-disable-next-line import/prefer-default-export
export const initialiseAuthLogin = async (): Promise<void> => {
  await checkAndUpdateCurrentDataset();
};
